import { Stack } from "@mui/material"
import { TEmailReportActivity } from "./types"
import { Button, Chip, DataTable, EEmailLogType, EEmailLogTypeParam, EmailAPIFactory, EmptyContent, EOperatorTypes, getCalendarFormat, getDate, getStartOfDate, LoadingContainer, SubNav, TDataTableColumnsData, TDataTableRowData, TEmailLog, TGenericListReturn, truncateText, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { TSubNavItem } from "@cakemail-org/ui-components-v2/dist/esm/components/subNav/types"
import { returnEmailTagsQuery } from "../../../utils/data"
import { getAPIDateRange } from "../../../utils/date"
import { NameTableCol } from "../../../components/tables/nameTableCol"
import { TagsTableCol } from "../../../components/tables/tagsTableCol"

export function EmailReportActivity({ search, timeRange, tagFilter }: TEmailReportActivity) {
    const { t, i18n } = useTranslation()

    const [page, setPage] = useState<number>(1)
    const [metrics, setMetrics] = useState<(TGenericListReturn<TEmailLog>)>()

    const [subNav, setSubNav] = useState<EEmailLogTypeParam>(EEmailLogTypeParam.submitted)

    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)

    useEffect(() => {
        setPage(1)
    }, [search, timeRange, tagFilter, subNav])

    useEffect(() => {
        fetchMetrics()
    }, [timeRange, tagFilter, page, search, subNav])

    function handlePaginationChange(cPage: number, cPerPage: number) {
        setPage(cPage)
    }

    function fetchMetrics() {
        setLoading(true)
        const apiTimeRange = getAPIDateRange({ range: timeRange })
        EmailAPIFactory.listLogs({
            tags: returnEmailTagsQuery(tagFilter, { operator: EOperatorTypes.and }),
            //email: search ? "~~" + search : undefined,
            page,
            perPage: 100,
            startTime: apiTimeRange.start,
            endTime: apiTimeRange.end,
            logType: subNav as unknown as EEmailLogTypeParam,
        }).then((data) => {
            setError(false)
            setMetrics(data)
            setLoading(false)
        }).catch(() => {
            setError(true)
        })
    }

    function handleSubNavClick(event: React.MouseEvent<HTMLButtonElement>, item: TSubNavItem) {
        setSubNav(item.name as EEmailLogTypeParam)
    }


    const colsData: TDataTableColumnsData[] = [
        {
            id: "email",
            label: t("general-email-address")
        },
        {
            id: "sender",
            label: t("general-sender_one")
        },
        {
            id: "timestamp",
            label: t("general-received"),
        },
        {
            id: "provider",
            label: t("general-provider"),
        },
        {
            id: "tags",
            label: t("general-tag_other"),
        },
        {
            id: "metadata",
            label: "Extra",
        },

        {
            id: "actions",
            label: ""
        }
    ]

    const rows: TDataTableRowData[] = metrics?.data?.map((activityRow) => {
        return {
            email: <NameTableCol ellipsis name={`${t("general-to")}: ${activityRow.email}`} desc={activityRow.subject} />,
            sender: <NameTableCol ellipsis name={`${t("general-from")}: ${activityRow.sender_name}`} desc={activityRow.sender_email} />,
            timestamp: getCalendarFormat({ unixDate: activityRow.time }),
            tags: <TagsTableCol tags={activityRow.tags} />,
            provider: activityRow.provider,
            metadata: Object.entries(activityRow.metadata).filter(objArr => {
                if (["reason", "url", "bounce_type", "error_message"].includes(objArr[0]) && objArr[1]) {
                    return true
                }
                return false
            }).map((objArr) => {
                return truncateText(objArr[1] as string, 40)
            })
            /*actions: <Button onClick={() => {

            }} size="small" color="body1" variant="outlined">a dropdown</Button>*/
        }
    }) || []


    const removeFromSubNav = [EEmailLogType.processing, EEmailLogType.global_unsubscribe_reason, EEmailLogType.queued, EEmailLogType.other]

    return <Stack className={`emailReportActivity ${loading ? "loading" : ""}`} gap={8}>
        <SubNav
            onClick={handleSubNavClick}
            items={Object.values(EEmailLogType).filter((lt) => !removeFromSubNav.includes(lt)).map((l) => {
                return {
                    name: l,
                    text: t("email-log-type-" + l)
                }
            })}
        />

        <LoadingContainer loading={!metrics && !error}>
            {metrics && <>
                <DataTable
                    columnsData={colsData}
                    rows={rows}
                    onPaginationChange={handlePaginationChange}
                    totalCount={metrics.pagination.count}
                    showPagination
                    hasMore={metrics.pagination.has_more}
                    controlledState={{ page }}
                //stickyLastCol
                />
            </>}
            {error && <EmptyContent
                title={t("analytic-block-loading-error-title")}
            />}
        </LoadingContainer>
    </Stack>
}